import { LocalStorageAdapter } from '../adapters/local-storage';

export function getInitialState<T extends Record<string, any>>(
  adapter: LocalStorageAdapter,
  defaultInitialState: T
) {
  let initial: T = { ...defaultInitialState };

  try {
    const keys = Object.keys(initial);

    keys.forEach((key) => {
      const value = adapter.getItem(key);

      if (value !== null) {
        initial = { ...initial, [key]: value };
      }
    });
  } catch {}

  return initial;
}

export function dumpState<T extends Record<string, any>>(
  adapter: LocalStorageAdapter,
  state: T
) {
  const keys = Object.keys(state);

  try {
    keys.forEach((key) => {
      adapter.setItem(key, state[key]);
    });
  } catch {}
}
